import React from "react";

import Shape5 from "../../../../../public/shape-5.svg";
import Shape7 from "../../../../../public/shape-7.svg";
import Shape8 from "../../../../../public/shape-8.svg";

import styles from "./styles.module.scss";

export const comments = [
  {
    content:
      "This team has helped me and my husband manage our house projects and get the best vendor for the work. The worst part about house projects is getting vendors to call you back and come for a quote. Humming Homes helps to eliminate that for us and creates an experience as if we have a personal assistant!",
    author: "Shari d.",
    icon: <Shape5 className={styles.icon} />
  },
  {
    content:
      "Humming Homes has been an absolute god send.  They are responsive, helpful and a pleasure to work with.  Knowing that I have them for my home has given me peace of mind. They are able to help me make informed decisions on my home projects and I am extremely grateful for the team.",
    author: "Aubrey G.",
    icon: <Shape7 className={styles.icon} />
  },
  {
    content:
      "Humming Homes is a gamechanger for new homeowners. They've pointed out tons of small things I wouldn't have otherwise known (a potential leak, a pest issue) that the inspector and others didn't bring to my attention previously. It's been so helpful to manage all home projects through an app.",
    author: "SARAH F.",
    icon: <Shape8 className={styles.icon} />
  }
];
